'use strict';
module.exports = require('../../full/json/stringify');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/json/stringify.js
// module id = 603
// module chunks = 13